/**
 * Walking worker view functionality for adventure locations
 */

WorkerView.prototype.initWalkingSprite = function () {
    this.sprite = new cleverapps.Spine(bundles.workers.jsons.walking_man);

    this.setMixForAllChops(this.sprite.listAnimations(), 0.2, 0.2, 0.3);

    this.sprite.setPosition(this.sprite.width / 2, this.sprite.height / 2);
    this.addChild(this.sprite);

    this.setContentSize(this.sprite.width, this.sprite.height);
};

WorkerView.prototype.highlight = function () {
    this._setGlobalZOrder(true);
};

WorkerView.prototype.unhighlight = function () {
    this._setGlobalZOrder(false);
};

WorkerView.prototype.setMixForAllChops = function (animNames, tWalkToChop, tIdleToChop, tChopToIdle) {
    const baseAndDir = function (name) {
        const m = name.match(/^(.*)_([ensw])$/);
        return m ? { base: m[1], dir: m[2] } : { base: name, dir: null };
    };

    const walks = animNames.filter((a) => a.startsWith("walk_"));
    const idles = animNames.filter((a) => a.startsWith("idle_"));
    const chops = animNames.filter((a) => a.startsWith("chop_"));

    walks.forEach((w) => {
        const wd = baseAndDir(w).dir;
        chops.forEach((c) => {
            if (baseAndDir(c).dir === wd) {
                this.sprite.setMix(w, c, tWalkToChop);
            }
        });
    });

    if (!cleverapps.skins.getSlot("skipWalkingWorkerAnimationMix")) {
        idles.forEach((i) => {
            const id = baseAndDir(i).dir;
            chops.forEach((c) => {
                if (baseAndDir(c).dir === id) {
                    this.sprite.setMix(i, c, tIdleToChop);
                }
            });
        });

        chops.forEach((c) => {
            const cd = baseAndDir(c).dir;
            idles.forEach((i) => {
                if (baseAndDir(i).dir === cd) {
                    this.sprite.setMix(c, i, tChopToIdle);
                }
            });
        });
    }
};

WorkerView.prototype.dashToCell = function (nextCell, direction) {
    this.stopAllActions();
    this.restorePosition(nextCell);

    if (direction) {
        this.currentDirection = direction;
    }
};

WorkerView.prototype.moveToCell = function (currentCell, nextCell, callback, arriveDirection, run) {
    const mapView = Map2d.currentMap.getMapView();
    const lastPosition = mapView.alignInGrid(currentCell.x, currentCell.y);
    const nextPosition = mapView.alignInGrid(nextCell.x, nextCell.y);

    const vector = cc.pSub(nextPosition, lastPosition);
    const duration = cc.pLength(vector) / cleverapps.styles.WorkerView.speed[run ? "run" : "walk"].value;
    const soundCoefficient = cleverapps.styles.WorkerView.speed[run ? "run" : "walk"].soundCoefficient || 1;

    const direction = this.currentDirection = this.chooseDirection(lastPosition, nextPosition, (dir) => this.sprite.hasAnimation(`walk_${dir}`));
    const nextAnimation = run && this.sprite.hasAnimation(`run_${direction}`) ? `run_${direction}` : `walk_${direction}`;
    if (arriveDirection) {
        this.currentDirection = arriveDirection;
    }

    const actions = [];
    actions.push(new cc.CallFunc(this.setSpriteAnimation.bind(this, nextAnimation, this.playStepsAction.bind(this, duration * soundCoefficient))));
    actions.push(new cc.MoveBy(duration / 2, cc.pMult(vector, 0.5)));
    actions.push(new cc.CallFunc(() => this.setMapPosition(Math.round(nextCell.x), Math.round(nextCell.y))));
    actions.push(new cc.MoveBy(duration / 2, cc.pMult(vector, 0.5)));
    actions.push(new cc.CallFunc(callback));

    this.stopAllActions();
    this.runAction(new cc.Sequence(actions));
};

WorkerView.prototype.showPathDots = function (path) {
    this.hidePathDots();
    if (!cleverapps.flags.get("walkingWorkerPathDebug")) {
        return;
    }

    const mapView = Map2d.currentMap.getMapView();
    const dots = new cc.DrawNode();
    path.forEach((cell) => dots.drawDot(mapView.alignInGrid(cell.x, cell.y), 8, cc.color(255, 220, 0, 255)));
    mapView.cloudsAbove.addChild(dots, 1000);
    this.pathDots = dots;
};

WorkerView.prototype.hidePathDots = function () {
    if (this.pathDots) {
        this.pathDots.removeFromParent();
        this.pathDots = undefined;
    }
};

WorkerView.prototype.hasWalkDirection = function (fromCell, toCell) {
    const mapView = Map2d.currentMap.getMapView();
    const direction = this.chooseDirection(
        mapView.alignInGrid(fromCell.x, fromCell.y),
        mapView.alignInGrid(toCell.x, toCell.y)
    );
    return this.sprite.hasAnimation(`walk_${direction}`);
};

cleverapps.whenAllInitialized(() => {
    cleverapps.flags.on("change:walkingWorkerPathDebug", (value) => {
        if (!value && Map2d.currentMap) {
            Map2d.currentMap.workers.regular.forEach((worker) => worker.view && worker.view.hidePathDots());
        }
    });
});

WorkerView.prototype.stopMoving = function () {
    this.hidePathDots();
    this.stopAllActions();
    this.playLastStepSound();
    this.animateIdle();
};

WorkerView.prototype.animateWorking = function (silent) {
    if (this.sprite) {
        const mapView = Map2d.currentMap.getMapView();

        const workerPosition = mapView.alignInGrid(this.worker.position.x, this.worker.position.y);
        const workablePosition = mapView.alignInGrid(this.worker.unit.x, this.worker.unit.y);

        const multiCell = this.worker.unit.findComponent(MultiCell);
        if (multiCell) {
            const centerDelta = multiCell.getCenter();
            workablePosition.x += centerDelta.x;
            workablePosition.y += centerDelta.y;
        }

        const direction = this.currentDirection = this.chooseDirection(workerPosition, workablePosition, (dir) => this.sprite.hasAnimation(`chop_${dir}`));
        let animation = `chop_${direction}`;

        const workingAnimation = cleverapps.skins.getSlot("getWorkingAnimation", this.worker.unit.code);
        if (workingAnimation && this.sprite.hasAnimation(`chop_${workingAnimation}_${direction}`)) {
            animation = `chop_${workingAnimation}_${direction}`;
        }

        this.setSpriteAnimation(animation, (duration) => {
            const timeScale = Map2d.animationsTimeScale();
            this.sprite.setTimeScale(1 / timeScale);

            return new cc.Sequence(
                new cc.DelayTime(0.35 * timeScale),
                new cc.CallFunc(() => {
                    const unitView = this.worker.unit && this.worker.unit.onGetView();
                    if (unitView) {
                        unitView.animateFlinch();
                    }
                }),
                new cc.DelayTime((duration - 0.35) * timeScale)
            );
        });

        if (!silent) {
            this.composite = cleverapps.effects.fire([
                `worker.mining.${this.worker.unit.code}`,
                "worker.mining"
            ]);
        }
    }
};

WorkerView.prototype.animateIdle = function () {
    if (this.sprite) {
        const animation = `idle_${this.currentDirection}`;
        if (this.sprite.hasAnimation(animation)) {
            this.setSpriteAnimation(animation);
            return;
        }
        this.setSpriteAnimation("idle_w");
    }
};

WorkerView.prototype.chooseDirection = function (from, to, filter) {
    const originalVector = cc.pSub(to, from);
    const vector = new cc.Point(Math.sqrt(2) * (originalVector.x + originalVector.y) / 2, Math.sqrt(2) * (-originalVector.x + originalVector.y) / 2);
    filter = filter || function () {
        return true;
    };
    const distance = (x, y, a, b) => Math.abs(a * x + b * y) / Math.sqrt(a * a + b * b);
    const directions = {
        n: [1, 0, 0, 1],
        ne: [-1, 1, 1, 1],
        e: [0, 1, 1, 0],
        se: [1, 1, 1, -1],
        s: [1, 0, 0, -1],
        w: [0, 1, -1, 0],
        sw: [-1, 1, -1, -1],
        nw: [1, 1, -1, 1]
    };

    const signX = Math.sign(vector.x);
    const signY = Math.sign(vector.y);

    let result = "w";
    let minDistance = Infinity;

    for (const name in directions) {
        if (!filter(name)) {
            continue;
        }
        const [a, b, dirSignX, dirSignY] = directions[name];

        if (dirSignX && dirSignX !== signX) {
            continue;
        }
        if (dirSignY && dirSignY !== signY) {
            continue;
        }

        const d = distance(vector.x, vector.y, a, b);
        if (d < minDistance) {
            minDistance = d;
            result = name;
        }
    }

    return result;
};

WorkerView.prototype.getViewPosition = function (rounded) {
    const mapView = Map2d.currentMap.getMapView();
    return mapView.getCellByCoordinates(this.getPosition(), !rounded);
};

WorkerView.prototype.setSpriteAnimation = function (animation, repeatActions) {
    if (this.lastAnimation === animation) {
        return 0;
    }
    this.lastAnimation = animation;

    this.sprite.stopAllActions();
    this.sprite.setCompleteListener();
    this.sprite.setTimeScale(1);
    this.sprite.setAnimation(0, animation, true);

    if (repeatActions) {
        this.sprite.runAction(new cc.RepeatForever(repeatActions(this.sprite.getTimeLeft())));
    }
};

WorkerView.prototype.playStepsAction = function (duration) {
    return new cc.Sequence(
        new cc.DelayTime(duration * 0.8),
        new cc.CallFunc(this.playStepSound.bind(this))
    );
};

WorkerView.prototype.playStepSound = function () {
    const cell = this.getViewPosition(true);
    const materials = Map2d.TILE_MATERIALS[cleverapps.meta.selectedLocationId()];
    const material = materials && materials[`${cell.x}_${cell.y}`] || cleverapps.skins.getSlot("workerDefaultStepSound") || "grass";

    const variant = PseudoRandom.GET().choose([1, 2, 3, 4]);
    cleverapps.effects.fire(`worker.step.${material}.${variant}`);
};

WorkerView.prototype.playLastStepSound = function () {
    const cell = this.getViewPosition(true);
    let material = "grass";
    if (Map2d.currentMap.isWaterUnit(cell.x, cell.y)) {
        material = cleverapps.skins.getSlot("isStoneTile", cell) ? "stone" : "wood";
    }
    cleverapps.effects.fire(`worker.step.${material}.stop`);
};
